var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "个人信息隐私政策",
        "append-to-body": true,
        width: "783px",
        top: "100px",
        visible: _vm.isVisible,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          staticStyle: { "font-size": "12px", "line-height": "20px" }
        },
        [
          _c("p", [
            _vm._v(
              "\n      本隐私政策（“隐私政策”）适用于由注册地址为上海市浦东新区江心沙路300号的巴斯夫（中国）有限公司（以下统称“巴斯夫”、“我方”、“我们”或“我们的”）通过网站、移动应用程序和其它在线门户(统称为“门户”)提供的有关BASF D’litE3-X\n      （以下简称“D’litE3-X）所有的服务（以下简称“服务”），这些门户是由BASF Digital Solution\n      GmbH开发并维护的。本隐私政策描述巴斯夫如何收集、使用、存储和分享通过门户获取的个人信息(以下简称“个人信息”)。我方将门户的访问者称为用户（“用户”或“您”）。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      巴斯夫深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守以下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，巴斯夫承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      请在使用我们的服务前，仔细阅读并了解本《个人信息隐私政策》。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("A、业务功能的个人信息收集使用规则")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      在下文中，我方希望告知您，当您使用本服务时，我方将如何处理个人信息。处理您个人信息的法律依据源于数据处理的必要性，以便提供您所要求的服务和功能，以及方便开具发票，在以下章节中另有说明的除外。我方还为巴斯夫集团的其他业务目的处理与服务相关的数据，如进一步开发、生产和/或营销我方的产品和服务（包括为了统计目的和持续改进我方的报价；在这些情况下，处理完全是以匿名为基础进行的，所以不会使得该个人数据追溯到您本人）。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      如果您使用我方的服务，您的浏览器出于技术目的会把某些数据传输到我方的网络服务器，以便我方提供您所访问的信息。为使您能够使用该服务，我方将收集、短期存储并使用以下数据。为了保护我方的合法利益，我方还会把这些数据存储一段限定的时间，以便在发生未经授权访问或试图访问本地服务器的情况下我方可以导出个人信息。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("1、我们收集和处理的个人信息")
            ]),
            _c("br"),
            _vm._v(
              "\n      为了使用我方服务的全部功能，您需要先注册一个用户账户。您可以在以后登录时设置个人登录信息。当您注册和随后登录时，我方会收集和处理以下有关您的个人信息： "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticStyle: { "list-style": "disc inside" } }, [
            _c("li", [_vm._v("姓氏和名字 ")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "联系方式（包括查询所需的电子邮件地址和电话号码/手机号码） "
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("用户名和密码 ")]),
            _vm._v(" "),
            _c("li", [_vm._v("登录的日志数据，包括时间戳 ")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      当您在使用D’litE3-X应用程序的时候，我们的应用程序将向您申请下述和个人信息有关的系统权限：使用摄像头、使用相册。您可以选择是否给予我们的应用程序该等系统权限。如您不授予该权限，将使我们无法为您提供我们应用程序中与该权限相关的功能，但您仍可继续使用我们应用程序中的其它功能。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      当你使用D’litE3-X服务时，我们会收集你的设备型号、操作系统、唯一设备标识符、国际移动设备识别码、登陆IP地址、MAC位址、D’litE3-X软件版本号、接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息等日志信息。这些日志信息只会为D’litE3-X提供参考服务，不会提供给任何第三方。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("2、处理个人信息的目的")
            ]),
            _c("br"),
            _vm._v(
              "\n      我们处理您的个人信息是为了保障您能够正常使用我们的服务，维护我们服务的正常运行，改进以及优化我们的服务体验以及保障你的账号安全。 "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("3、信息的存储、分享和委托处理")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v("\n      （1）存储 "),
            _c("br"),
            _vm._v(
              "\n      我们会按照法律法规规定，将境内收集和产生的用户个人信息存储于中国境内。 "
            ),
            _c("br"),
            _vm._v(
              "\n      一般而言，我们仅在为实现目的所必需的时间内保留你的个人信息。例如：若你需要使用D’litE3-X服务，我们需要一直保存你的手机号码，以保证你正常使用我们的服务。当你注销D’litE3-X帐户后，该信息将被自动删除；\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      当您送了评论信息，我们需要保存您的相应信息，以保证您正常使用评论功能。而当您删除了您的评论信息后，我们也将删除相应的信息。 "
            ),
            _c("br"),
            _vm._v("\n      （2） 分享 "),
            _c("br"),
            _vm._v(
              "\n      我们不会与本公司及本公司关联公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。“关联公司”应指，就本公司而言，直接或间接控制该方或受其控制，或与该方同受直接或间接控制的任何实体。如果控制人直接或间接地拥有该实体至少百分之五十（50%）的股权的所有权或有权利影响该实体的管理层。\n      "
            ),
            _c("br"),
            _vm._v("\n      （3） 委托处理 "),
            _c("br"),
            _vm._v(
              "\n      本业务功能中某些具体的模块或功能由外部供应商提供。例如我们会聘请服务提供商来协助我们提供客户支持。 "
            ),
            _c("br"),
            _vm._v(
              "\n      对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本个人信息保护政策以及其他任何相关的保密和安全措施来处理个人信息。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("4、Cookies的使用")
            ]),
            _c("br"),
            _vm._v(
              "\n      当您浏览我们的网站时，我们会通过Cookie横幅通知您我们使用了Cookie。您需要接受Cookie的使用以继续浏览我们的网站。Cookie\n      是一种可让网站服务器将数据存储于客户端或从客户端中读取数据的中立技术。指定给您的Cookies是唯一的，Cookie\n      内容通常均经过加密。Cookie可在您接入我们的服务时通知我们，以使我们可验证您的身份信息，以确保您的账号安全。Cookie可帮助我们保障数据和服务的安全性，排查针对我们的产品和服务的作弊、黑客、欺诈行为。 "
            ),
            _c("br"),
            _vm._v(
              "\n      我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以根据自己的需要来修改浏览器的设置以接受或者拒绝Cookies。另外，您也可以清除软件内保存的所有Cookies。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      关于Cookie使用的详情，请您查询D’litE3-X网站上的Cookie横幅。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("5、保护个人信息的安全技术措施")
            ]),
            _c("br"),
            _vm._v(
              "\n      我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。我们努力为用户的信息安全提供保障，以防止信息的丢失、不当使用、未经授权访问或披露。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      D’litE3-X采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全。我们会全面保护用户的个人数据，不会泄露给任何未经授权的第三方。我们严格限制访问您个人信息的人员范围，要求他们遵守保密义务，并进行审查。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      当我们的产品或服务发生停止运营的情形时，我们将以推送通知、公告等形式通知你，并在合理的期限内删除你的个人信息或进行匿名化处理（所谓“匿名化处理”，是指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。个人信息经匿名化处理后所得的信息不属于个人信息。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "14px" } }, [
              _vm._v("6、软件开发工具包(SDK)的整合")
            ]),
            _c("br"),
            _vm._v(
              "\n      为保障相关功能的实现及应用的安全稳定的运行，D’litE3-X整合了以下软件开发工具包（SDKs）： "
            ),
            _c("br"),
            _vm._v(
              "\n      - 为了通知您我们的新产品或新服务，整合了com.umeng (友盟), 以推送通知、公告。 "
            ),
            _c("br"),
            _vm._v("\n      - 为了实现视频模块的功能，整合了Kaltura "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://video.dlite3.basf.com",
                  target: "_blank"
                }
              },
              [_c("u", [_vm._v("https://video.dlite3.basf.com")])]
            ),
            _vm._v("。 "),
            _c("br"),
            _vm._v(
              "\n      我们的隐私政策不适用于第三方提供的产品或服务。取决于您所使用的巴斯夫的产品或服务，当您使用这些产品或服务时，也可能收集您的信息。因此，我们强烈建议您花时间阅读该第三方的隐私政策，就像阅读我们的隐私政策一样。我们的隐私政策不适用于通过我们的服务链接的其他网站。\n      "
            ),
            _c("br"),
            _vm._v(
              "\n      以下提供了当您使用上述特定产品或服务时，所适用的第三方条款和隐私政策的示例： "
            ),
            _c("br"),
            _vm._v("\n      -  com.umeng 友盟隐私政策："),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.umeng.com/page/policy",
                  target: "_blank"
                }
              },
              [
                _c("u", [_vm._v("https://www.umeng.com/page/polic")]),
                _c("u", [_vm._v("y")])
              ]
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v("\n      - video.dlite3.basf.com Kaltura隐私政策："),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://corp.kaltura.com/legal/privacy/privacy-policy/",
                  target: "_blank"
                }
              },
              [
                _c("u", [
                  _vm._v(
                    "https://corp.kaltura.com/legal/privacy/privacy-policy/"
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("B、关于您的权利")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("您可以根据适用的个人信息保护的法律法规行使以下权利： "),
            _c("br"),
            _vm._v("\n      1、访问您的已保存的个人信息； "),
            _c("br"),
            _vm._v("\n      1)  进入D’litE3-X后，点击“用户中心”； "),
            _c("br"),
            _vm._v("\n      2)   点击“个人资料”。 "),
            _c("br"),
            _vm._v("\n      2、更正您的个人信息 "),
            _c("br"),
            _vm._v("\n      1)   进入D’litE3-X后，点击“用户中心”； "),
            _c("br"),
            _vm._v("\n      2)   点击“个人资料”； "),
            _c("br"),
            _vm._v(
              "\n      3)   修改姓名、电话号码、登录密码和电子邮件地址等； "
            ),
            _c("br"),
            _vm._v("\n      4)   修改完毕点击确认按钮。 "),
            _c("br"),
            _vm._v(" "),
            _c("strong", [_vm._v("3")]),
            _c("strong", [_vm._v("、")]),
            _vm._v("删除您的个人信息 "),
            _c("br"),
            _vm._v(
              "\n      在以下情形中，您可以向我们提出删除个人信息的请求：\n    "
            )
          ]),
          _vm._v(" "),
          _c("ul", { staticStyle: { "list-style": "disc inside" } }, [
            _c("li", [_vm._v("如果我们处理个人信息的行为违反法律法规；  ")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("如果我们收集、使用您的个人信息，却未征得您的同意；  ")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("如果我们处理个人信息的行为违反了与您的约定；  ")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("如果您不再使用我们的产品或服务，或您注销了账号；  ")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("如果我们不再为您提供产品或服务。  ")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其立即删除，除非法律法规另有规定，或这些实体获得您的独立授权。 "
            ),
            _c("br"),
            _vm._v(
              "\n      当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。 "
            ),
            _c("br"),
            _vm._v("\n      4、撤回您的授权同意 "),
            _c("br"),
            _vm._v(
              "\n      您可以随时撤回您对个人信息的收集、存储、处理、使用和传输所给予的授权同意。 "
            ),
            _c("br"),
            _vm._v(
              "\n      当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。 "
            ),
            _c("br"),
            _vm._v("\n      5. 注销您的账户 "),
            _c("br"),
            _vm._v("\n      1)   进入D’litE3-X后，点击“用户中心”； "),
            _c("br"),
            _vm._v("\n      2)   点击“个人资料”； "),
            _c("br"),
            _vm._v("\n      3）  点击“安全设置” "),
            _c("br"),
            _vm._v("\n      4)   点击“账号注销”； "),
            _c("br"),
            _vm._v("\n      5)   点击“申请注销”按钮。 "),
            _c("br"),
            _vm._v("\n      6. 获取个人信息副本 "),
            _c("br"),
            _vm._v(
              "\n      您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可通过发送邮件通过发邮件至CS.DlitE3-X@basf.com，我们会要求您提供相关必要资料及信息对您进行个人信息校验。完成个人信息主体确认后，在符合相关法律规定且技术可行的前提下，我们将根据您的要求在十五（15）个工作日将您的个人信息副本通过邮件发送给您。\n      "
            ),
            _c("br"),
            _vm._v("\n      7. 要求我们响应您的上述请求 "),
            _c("br"),
            _vm._v(
              "\n      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。 "
            ),
            _c("br"),
            _vm._v(
              "\n      原则上我们将在核实您的身份后七（7）天内对您的上述请求做出答复。如您不满意，还可以通过发邮件至"
            ),
            _c("a", { attrs: { href: "mailto:CS.DlitE3-X@basf.com" } }, [
              _c("u", [_vm._v("CS.DlitE3-X@basf.com")])
            ]),
            _c("u"),
            _vm._v(
              "进行投诉。我们将尽快对有关问题进行调查并在十五（15）工作日内给予您回复。\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("C、联系方式")
            ]),
            _c("br")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      如果您对数据保护有任何疑问，请通过以下地址联系我方的集团数据保护专员：集团数据保护专员：Alexandra Haug（数据保护专员），地址：德意志联邦共和国路德维希港，邮编67056，电话：+49 (0) 621\n      60-0，邮箱："
            ),
            _c("a", { attrs: { href: "mailto:data-protection.eu@basf.com" } }, [
              _c("u", [_vm._v("data-protection.eu@basf.com")])
            ]),
            _c("u"),
            _c("u", [_vm._v("。")]),
            _c("u")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", { staticStyle: { "font-size": "16px" } }, [
              _vm._v("D、个人信息隐私政策调整")
            ]),
            _c("br")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      我方保留随时更新本个人信息隐私政策的权利。本数据隐私政策的任何更新应在我方的门户上发布。修正案一经在我方的门户上公布即适用。因此，我方建议您定期访问我方的门户，以便在必要时随时了解任何更新。 "
            ),
            _c("br"),
            _vm._v("\n      最后更新日期： [ 2021年12月07日 ] ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.isVisible = false
                }
              }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c89e9fe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c89e9fe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/agreement/Prcn.vue
// module id = null
// module chunks = 